/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_Category_SalesInputs */



/**
* | output |
* | --- |
* | "Sales" |
*
* @param {Agent_Templates_Category_SalesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_category_sales = /** @type {((inputs?: Agent_Templates_Category_SalesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Category_SalesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertrieb")
	return /** @type {LocalizedString} */ ("Sales")
});